import styles from "./hoverOAPhone.scss";
const HoverOAPhone = (props) => {
    let iconClose=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    let style1=styles.popUp1;
    let style2=styles.popUp2;
    let style3=styles.popUp3;  
    let hoverStyle=props.hoverText==='voice' ? styles.hoverVoiceStyle:styles.hoverTextStyle;
    let popUp=props.preferenceDataPhone && props.preferenceDataPhone.length===1 ? style1 : props.preferenceDataPhone && props.preferenceDataPhone.length===2 ? style2 : style3;
  return (
    <div className={popUp}>
    <div className={styles.popupContent + ' '+ hoverStyle}>
    <div className={styles.closeIcon}>  <img className={styles.closeIconAlign} 
        src={iconClose} onClick={props.handleClose} alt="close Icon" /></div>
     <div className={styles.marginSpace}>
     {props.preferenceDataPhone && props.preferenceDataPhone.map(phone =>

        <p className={styles.hoverTable}>{phone}</p>
        )
      }
    </div>
    </div> 
    </div>
);};
 
export default HoverOAPhone;